import {
  Button,
  Card,
  CardSection,
  Group,
  Image,
  Overlay,
} from '@mantine/core';
import { Award, Info, Lock } from 'lucide-react';
import classes from './card.module.css';
import { Link } from 'react-router-dom';
import { ICourse } from '../../interfaces/ICourse.tsx';
import { getShopProductUrl } from '../../utils/shopUrl';

export default function CourseCard(props: { c: ICourse; style: any }) {
  const { c } = props;

  const handleCardClick = () => {
    if (c.unlocked) {
      // Naviga internamente
      window.location.href = `/proCourses/${c.id}`;
    } else {
      window.open(getShopProductUrl(c.slug), '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card
      shadow='sm'
      withBorder
      onClick={handleCardClick}
      className={classes.card}
    >
      <CardSection>
        <div className={classes.imageWrapper} style={{ position: 'relative' }}>
          <Image src={c.image} mb='md' alt={c.name} />
          {!c.unlocked && (
            <>
              <Overlay
                color='#000'
                backgroundOpacity={0.6}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 1,
                }}
              />
              <Lock
                size={32}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#fff',
                  zIndex: 2,
                }}
              />
            </>
          )}
        </div>
      </CardSection>

      {c.unlocked ? (
        <Button
          variant='light'
          component={Link}
          leftSection={c.completed ? <Award size={16} /> : null}
          to={`/proCourses/${c.id}`}
          color={c.completed ? 'green' : 'blue'}
          fullWidth
          radius='sm'
        >
          {c.completed ? 'Completato' : 'Vai al corso'}
        </Button>
      ) : (
        <Group>
          <Button
            leftSection={<Info size={16} />}
            variant='outline'
            fullWidth
            onClick={() => {
              window.open(
                getShopProductUrl(c.slug),
                '_blank',
                'noopener,noreferrer'
              );
            }}
            radius='sm'
          >
            Sblocca
          </Button>
        </Group>
      )}
    </Card>
  );
}
